const ITEMS = ["Batu Bolong", "Berawa", "Echo Beach", "Oberoi", "Petitenget", "Double Six"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-stone-900/10 bg-sand py-5"
    >
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-serif text-2xl font-light italic tracking-wide text-stone-500 sm:text-3xl"
              >
                <span className="px-8">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-gold" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
